import { render, staticRenderFns } from "./dashboard_meun_bind_dialog.vue?vue&type=template&id=5975ad2c"
import script from "./dashboard_meun_bind_dialog.vue?vue&type=script&lang=js"
export * from "./dashboard_meun_bind_dialog.vue?vue&type=script&lang=js"
import style0 from "./dashboard_meun_bind_dialog.vue?vue&type=style&index=0&id=5975ad2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports